const SIGNS = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
const ABBR = {
  Sun: "Su", Moon: "Mo", Mercury: "Me", Venus: "Ve", Mars: "Ma", Jupiter: "Ju",
  Saturn: "Sa", Uranus: "Ur", Neptune: "Ne", Pluto: "Pl", Rahu: "Ra", Ketu: "Ke",
};

// North Indian Kundli: fixed diamond houses, ascendant sign in house 1 (top-center).
// Label centres as fractions of the box.
const HOUSE_POS = [
  [0.5, 0.25],  [0.25, 0.11], [0.11, 0.25], [0.25, 0.5],
  [0.11, 0.75], [0.25, 0.89], [0.5, 0.75],  [0.75, 0.89],
  [0.89, 0.75], [0.75, 0.5],  [0.89, 0.25], [0.75, 0.11],
];

export function KundliChart({ vedic, size = 300, accent = "#45F0DF", title }) {
  const ascIdx = SIGNS.indexOf(vedic.ascendant.sign);
  const byHouse = Array.from({ length: 12 }, () => []);
  vedic.planets.forEach((p) => {
    if (p.planet === "Ketu") return; // keep it readable; Rahu axis implies Ketu
    const h = ((SIGNS.indexOf(p.sign) - ascIdx + 12) % 12);
    byHouse[h].push(p);
  });
  const ketu = vedic.planets.find((p) => p.planet === "Ketu");
  if (ketu) {
    const h = ((SIGNS.indexOf(ketu.sign) - ascIdx + 12) % 12);
    byHouse[h].push(ketu);
  }

  const S = size;
  const m = (x, y) => [x * S, y * S];

  return (
    <svg viewBox={`0 0 ${S} ${S}`} className="w-full h-auto">
      <rect x="1" y="1" width={S - 2} height={S - 2} fill="rgba(5,5,10,0.4)" stroke="rgba(255,255,255,0.18)" />
      {/* diagonals */}
      <line {...lineProps(m(0, 0), m(1, 1))} />
      <line {...lineProps(m(1, 0), m(0, 1))} />
      {/* inner diamond */}
      <polygon
        points={`${S / 2},0 ${S},${S / 2} ${S / 2},${S} 0,${S / 2}`}
        fill="none" stroke="rgba(255,255,255,0.18)"
      />
      {HOUSE_POS.map(([fx, fy], i) => {
        const [x, y] = m(fx, fy);
        const signNum = ((ascIdx + i) % 12) + 1;
        const planets = byHouse[i];
        return (
          <g key={i}>
            <text x={x} y={y - 8 - planets.length * 5} fill="rgba(212,175,55,0.75)" fontSize="9" textAnchor="middle">
              {signNum}
            </text>
            {planets.map((p, j) => (
              <text
                key={p.planet}
                x={x}
                y={y + 4 + (j - (planets.length - 1) / 2) * 12}
                fill={p.planet === "Rahu" || p.planet === "Ketu" ? "#B47CF0" : accent}
                fontSize="10.5"
                textAnchor="middle"
                fontWeight="500"
              >
                {ABBR[p.planet]}{p.retrograde && p.planet !== "Rahu" && p.planet !== "Ketu" ? "\u1d3f" : ""}
              </text>
            ))}
          </g>
        );
      })}
    </svg>
  );
}

function lineProps([x1, y1], [x2, y2]) {
  return { x1, y1, x2, y2, stroke: "rgba(255,255,255,0.14)" };
}
